import React, { useMemo } from 'react'
import block from 'bem-cn'

import { Icon } from 'components/UIKit/Icon'
import { getPaginationPages } from 'components/UIKit/Pagination/Pagination'
import { UsePaginationReturn } from 'components/UIKit/Table'

import './DesktopPagination.scss'

export type DesktopPaginationProps = {
  isDisabled?: boolean
  pagination: UsePaginationReturn
}

const b = block('desktop-pagination')

export const DesktopPagination: React.FC<DesktopPaginationProps> = ({ pagination, isDisabled }) => {
  const pages = useMemo(
    () => getPaginationPages(pagination.totalPages, pagination.page),
    [pagination.page, pagination.totalItems],
  )

  return (
    <div className={b()}>
      <button
        type="button"
        onClick={pagination.onPrevPage}
        disabled={!pagination.hasPrevious || isDisabled}
        className={b('button')}>
        <Icon type="Caret_Down" className={b('button-arrow')} />
      </button>

      <div className={b('pages')}>
        {pages.map(page => (
          <button
            className={b('page', { isActive: pagination.page === page, clickable: typeof page === 'number' })}
            onClick={() => typeof page === 'number' && pagination.onChangePage(page)}>
            {page}
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={pagination.onNextPage}
        disabled={!pagination.hasNext || isDisabled}
        className={b('button')}>
        <Icon type="Caret_Down" className={b('button-arrow').mix('next')} />
      </button>
    </div>
  )
}
